import { render, staticRenderFns } from "./Opz2Page.vue?vue&type=template&id=631aaddd"
import script from "./Opz2Page.vue?vue&type=script&lang=ts"
export * from "./Opz2Page.vue?vue&type=script&lang=ts"
import style0 from "./Opz2Page.vue?vue&type=style&index=0&id=631aaddd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports